import classnames from 'classnames';
import React, { FC } from 'react';
import { GenericLayout } from '../Generic';
import { ILayout } from '../types';
import { ListFile } from './ListFile';
import { ListFolder } from './ListFolder';
import styles from './ListLayout.scss';
import { ListLoadingIndicator } from './ListLoadingIndicator';

export const ListLayout: FC<ILayout> = ({
  className,
  isLoading,
  hasMoreItems,
  children,
  onClick,
  onContextMenu,
  loadMoreItems,
  resetFilesStream,
  itemsCount,
  extendedFiltersElement,
  selectItem,
}) => (
  <GenericLayout
    className={classnames(styles.list, className)}
    isLoading={isLoading}
    hasMoreItems={hasMoreItems}
    itemsClassName={styles.items}
    onClick={onClick}
    onContextMenu={onContextMenu}
    loadMoreItems={loadMoreItems}
    dataHook="list-layout"
    resetFilesStream={resetFilesStream}
    itemsCount={itemsCount}
    extendedFiltersElement={extendedFiltersElement}
    selectItem={selectItem}
  >
    {children({
      File: ListFile,
      Folder: ListFolder,
      LoadingIndicator: ListLoadingIndicator,
      itemClassName: styles.item,
    })}
  </GenericLayout>
);
